var Subhead = function() {

	var comp = $('[data-component="subhead"]');

	this.init = function() {

		this.openMenu();

	};

	this.openMenu = function(){

		comp.find('.arrow').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('active');
			comp.find('.submenu').slideToggle(300);
		});

	};

	return this.init();

};
